import React from 'react';
import { clsx } from 'clsx';

export const InputLabel = ({
  label,
  required = false,
  disabled = false,
  htmlFor,
  id,
}: {
  label: string;
  required?: boolean;
  disabled?: boolean;
  htmlFor?: string;
  /** Do `aria-labelledby` pól, które nie są jednym `<input>` — np. grupy radiowej. */
  id?: string;
}) => {
  return (
    <label
      id={id}
      className={clsx('text-xs font-normal leading-[120%]', {
        'text-neutral-700': !disabled,
        'text-basic-disabled-main': disabled,
      })}
      htmlFor={htmlFor}
    >
      {label}
      {required && <span className="text-error-200"> *</span>}
    </label>
  );
};

export default InputLabel;
